import { render, staticRenderFns } from "./ForEmployersWorkForceSection.vue?vue&type=template&id=b6276c0e&"
import script from "./ForEmployersWorkForceSection.vue?vue&type=script&lang=js&"
export * from "./ForEmployersWorkForceSection.vue?vue&type=script&lang=js&"
import style0 from "./ForEmployersWorkForceSection.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports